/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kpf3Inputs */

const de__field_kpf3 = /** @type {(inputs: _Field_Kpf3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPF`)
};

/**

* @param {_Field_Kpf3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kpf3 = /** @type {((inputs?: _Field_Kpf3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kpf3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kpf3(inputs)
});
export { _field_kpf3 as "_field_KPF" }